import { render, staticRenderFns } from "./FlowAttr.vue?vue&type=template&id=2e338c2b"
import script from "./FlowAttr.vue?vue&type=script&lang=js"
export * from "./FlowAttr.vue?vue&type=script&lang=js"
import style0 from "./FlowAttr.vue?vue&type=style&index=0&id=2e338c2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports